<template>
  <div data-component-group="filter-forms" data-component="label">
    <FiltersForm
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />
    </FiltersForm>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import FiltersForm from './FiltersBase.vue';
  import { isNonEmptyArr, escapeSearch } from '../../../utils';

  // TODO: Translate component

  export default defineComponent({
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        search: null as string | null,
        selectedCountries: [] as string[],
      };
    },
    computed: {
      hasFilters() {
        const { search, selectedCountries } = this;

        return !!search || isNonEmptyArr(selectedCountries);
      },
    },
    methods: {
      onFilter() {
        const { search, selectedCountries } = this;
        const formattedSearch = escapeSearch(search);

        this.$emit('filter', {
          search: formattedSearch,
          countries: selectedCountries,
        });
      },
      onClearFilters() {
        this.search = null;
        this.selectedCountries = [];

        this.$emit('clearFilters');
      },
    },
  });
</script>
